import React from 'react';
export function OpeningHook() {
  return <section className="bg-cream section-padding text-center md:text-left" data-id="element-203">
      <div className="max-w-3xl mx-auto" data-id="element-204">
        <p className="text-2xl md:text-3xl font-serif text-navy-dark leading-relaxed italic" data-id="element-205">
          "Imagina por un momento que mañana no estás aquí. Tu familia tiene las
          llaves de tu casa y de tu auto, pero se enfrentan a un muro invisible:
          tu teléfono está bloqueado, tu banco pide códigos que solo llegan a tu
          celular, y tus fotos de toda una vida están atrapadas en una 'nube'
          cuya contraseña nadie conoce."
        </p>
        <div className="gold-divider" data-id="element-206"></div>
        <p className="text-xl text-gray-700 leading-relaxed" data-id="element-207">
          No es solo una molestia administrativa; es una tragedia emocional. En
          un instante, décadas de recuerdos y el acceso a tus activos
          financieros podrían desaparecer para siempre, dejando a tus seres
          queridos en un laberinto legal y tecnológico en el momento que más
          sufren.
        </p>
      </div>
    </section>;
}